<template>
  <div class="prototype">
    <iframe
      :src="embedUrl"
      frameborder="0"
      allowfullscreen
      :class="prototype.target === 'app' ? 'contentMobile' : 'contentWeb'"
    />
    <img
      :src="targetMockup"
      :alt="targetMockupLabel"
      :class="prototype.target === 'app' ? 'mobileFrame' : 'frame'"
    />
  </div>
</template>

<script lang="ts">
import type { Prototype } from "@/types/prototype";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "PrototypeComponent",
  props: {
    prototype: {
      type: Object as PropType<Prototype>,
      required: true,
    },
  },
  computed: {
    embedUrl(): string {
      return this.prototype.prototype;
    },
    targetMockup(): string {
      return require(this.prototype.target === "app"
        ? "@/assets/phone-mockup.webp"
        : "@/assets/laptop-mockup.webp");
    },
    targetMockupLabel(): string {
      return this.prototype.target === "app"
        ? "iPhone 12 Pro Max - Mockup"
        : "MacBook Pro 2023 - Mockup";
    },
  },
});
</script>

<style scoped>
.prototype {
  --p-height: 2804;
  --s-aspect-ratio: 1290 / 2796;
  --f2s-height-ratio: var(--p-height) / 2936;
  --f2s-width-ratio: var(--p-height) * var(--s-aspect-ratio) / 1450;

  width: min-content;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
}

.prototype > .contentMobile {
  background-color: #fafafa;
  height: calc(var(--f2s-height-ratio) * 100%);
  width: calc(var(--f2s-width-ratio) * 100%);
  border-radius: 12.4%/5.7%;
  position: absolute;
}

.prototype > .contentWeb {
  background-color: #fafafa;
  height: calc(var(--f2s-height-ratio) * 90%);
  width: calc(var(--f2s-width-ratio) * 90%);
  border-radius: 12.4%/5.7%;
  position: absolute;
}

.prototype > .frame {
  pointer-events: none;
  width: auto;
  height: auto;
  max-height: var(--prototype-max-height);
  max-width: calc(
    100vw - var(--sidebar-width) - 2 * var(--prototype-padding-x) -
      2 * var(--prototype-web-padding-x)
  );
  z-index: 999;
}
.prototype > .mobileFrame {
  pointer-events: none;
  width: auto;
  height: auto;
  max-height: var(--prototype-max-height);
  z-index: 999;
}
</style>
